import type { JSX } from 'react';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconStar } from '@change-corgi/design-system-legacy/icons';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

type Props = {
	text: string;
	selected: boolean;
	isSunriseEnabled: boolean;
};

export function HighlightText({ text, selected, isSunriseEnabled }: Props): JSX.Element {
	return (
		<Box
			sx={{
				textAlign: 'center',
				backgroundColor: selected ? 'secondary-blue' : 'neutral-grey400',
				color: 'primary-white',
				borderTopLeftRadius: 'standard',
				borderTopRightRadius: 'standard',
				...(isSunriseEnabled && {
					backgroundColor: 'white',
					color: selected ? 'sunrise.semantic.typography.accent.primary' : 'sunrise.semantic.typography.text.strong',
					borderTopLeftRadius: 11, // the parent box has a border radius of 12, so we need to subtract 1px to avoid the border overlap
					borderTopRightRadius: 11, // the parent box has a border radius of 12, so we need to subtract 1px to avoid the border overlap
					alignItems: 'center',
					justifyContent: 'flex-start',
					display: 'flex',
					px: 24,
					pt: 16,
				}),
			}}
		>
			<Flex
				sx={{
					alignItems: 'center',
					justifyContent: 'center',
					py: 4,
					...(isSunriseEnabled && {
						fontSize: 24,
						py: 0,
						px: 8,
						borderRadius: 999,
						backgroundColor: selected ? 'sunrise.semantic.fill.accent.primary.weaker' : 'sunrise.semantic.fill.weaker',
						gap: 4,
					}),
				}}
			>
				<Icon
					icon={iconStar}
					size="l"
					color="secondary-yellow"
					data-qa="ppmu-modal-highlight-icon"
					{...(isSunriseEnabled && {
						color: selected ? 'sunrise.semantic.icon.accent.primary' : 'sunrise.semantic.icon.text.strong',
					})}
				/>
				<Text fontWeight="semibold" size="caption" data-qa="ppmu-modal-highlight-text">
					{text}
				</Text>
			</Flex>
		</Box>
	);
}
